// extracted by mini-css-extract-plugin
module.exports = {"list":"index-page-content-module--list--3kwDr","indexDescription":"index-page-content-module--indexDescription--hYKiE"};